import { Feature, LineString, MultiPolygon, Polygon, Position } from "geojson";

import { booleanIntersects } from "fond/turf";

/**
 * Return the start and end coordinates of a LineString feature.
 *
 * Will raise an error if the LineString is empty.
 *
 * @param feature The LineString feature
 */
export function getLineStringEndpoints(feature: Feature<LineString>): [Position, Position] {
  const coords = feature.geometry.coordinates;
  return [coords[0], coords[coords.length - 1]];
}

/**
 * Return the features whose geometry intersects the given geometry.
 *
 * Features without a geometry are excluded.
 */
export function filterFeaturesByGeometry(features: Feature[], geometry: Polygon | MultiPolygon): Feature[] {
  return features.filter((feature) => feature.geometry !== null && booleanIntersects(feature, geometry));
}
